// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { HeadProvider } from 'react-head';
import ScriptTag from 'react-script-tag';

import formatDate from '../utilities/formatDate';
import renderHTML from 'react-render-html';

import '../styles/user.css';

const NUM_NOTIFY = 2;

export default class User extends React.Component {

    state = {
        menuOpen: false,
        switchTeam: false,
        filterTeam: ""
    }

    componentDidMount = () => {
        document.addEventListener("click", this.handleClickOutside);

        if ((!this.props.user || !this.props.user._id) && window.innerWidth > 1200) setTimeout(() => {
            if (!this.props.user || !this.props.user._id)
                this.setState({ menuOpen: true });
        }, 4000);
    }

    componentWillUnmount = () => {
        document.removeEventListener("click", this.handleClickOutside);
    };
    
    // This function ensures proper opening and closing of the user-icon menu
    handleClickOutside = (event) => {
        const menu = document.querySelector(".user-icon");
        if (menu && !menu.contains(event.target)) {
          this.setState({ menuOpen: false });
        }
    };

    getNotificationIcon = (n) => {
        if (!n.title)
            return "default.png";

        if (n.title.includes("assign"))
            return "assigned.png";

        if (n.title.includes("error"))
            return "error.png";
        
        if (n.title.includes("tagged"))
            return "tag.png";

        return "default.png";
    }

    getChecklist = (u,t) => {

        if (!u.isAdmin)
            return [];

        let checklist = [];

        if (t && t.numStacks < 1)
            checklist.push({
                title: "Create your first stack!",
                subtitle: "My Stacks",
                body: "Go to <a href=\"/\">My Stacks</a> and click on the \"<i>Create a new stack</i>\" card."
            });

        if (t && t.users && t.users.length < 2)
            checklist.push({
                title: "Invite a team member",
                subtitle: "Team Users",
                body: "Go to the <a href=\"/settings/team\">Team Members</a> settings page and click on the \"<i>Invite a new user</a>\" card to get started!"
            });

        if (t && t.email && t.email.settings && t.email.settings.length < 1)
            checklist.push({
                title: "Connect an email account",
                subtitle: "Inbound Email",
                body: "Stax can pull attachments directly from your email!<br /><br />Go to the <a href=\"/settings/email\">Inbound Email</a> settings page to connect an account."
            });

        return checklist;
    }

    render = () => {
        
        const user = this.props.user;
        const nNotify = user.notifications ? user.notifications.length : 0;
        const checklist = []; // this.getChecklist(user, this.props.team);

        return (<>
            {(!user || !user._id) && window.location.href.includes("/public/") && <HeadProvider>
                <ScriptTag type="text/javascript" src="/chat.public.js" />
                <ScriptTag type="text/javascript" src="https://leadbooster-chat.pipedrive.com/assets/loader.js" async />
            </HeadProvider>}
            <div
                className={"user-icon" + (user.notified || checklist.length > 0 ? " user-notified" : "") + (this.props.className ? " " + this.props.className : "")}
                onClick={() => {
                    this.setState({ menuOpen: !this.state.menuOpen });
                    this.props.updateUser({
                        _id: user._id,
                        notified: false
                    }, false);
                }}    
            >
                
                {user.name ? user.name[0].toUpperCase() : "M"}
                {nNotify + checklist.length > 0 && <div 
                    className="user-notifications-alert"
                    style={{
                        fontSize: nNotify > 99 ? '10px' : nNotify > 9 ? '12px' : '14px',
                        lineHeight: nNotify > 99 ? '21px' : nNotify > 9 ? '21px' : '20px'
                    }}
                >
                    {checklist.length + nNotify}
                </div>}
                
                {this.state.menuOpen && <img
                    className="user-menu-arrow"
                    src={"https://static.stax.ai/images/icons/" + (user && user.enableDarkMode ? "dark/" : "") + "arrow-menu" + (user && user._id ? "" : "-public") + ".png"}
                    alt=""
                />}

                <div className={"user-menu" + (this.state.menuOpen ? "" : " user-menu-closed")}>
                    {user?._id ? <>

                        <h1>Hi{user.name ? " " + user.name.split(" ")[0] : ""}!</h1>

                        {this.props.team && user?.memberships?.length && user.memberships.length > 1 ? <div className="user-menu-team">
                            {this.state.switchTeam ? <>
                                <div className="user-menu-team-current">Select team</div>
                                <div
                                    className="user-menu-team-switch"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.setState({ switchTeam: false });
                                    }}
                                >Cancel</div>
                                <div className="user-menu-team-options-container">
                                    <input
                                        type="text"
                                        className="user-menu-team-filter"
                                        value={this.state.filterTeam}
                                        onChange={e => this.setState({
                                            filterTeam: e.target.value
                                        })}
                                        onClick={e => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }}
                                        placeholder="Find team..."
                                    />
                                    <div className="user-menu-team-options">
                                        {user.memberships.filter(m => m.name?.length && m.name?.toLowerCase()?.includes(this.state.filterTeam?.toLowerCase())).sort((a,b) => a.name.localeCompare(b.name)).map((m,i) => <div
                                            key={i}
                                            className={"user-menu-team-option" + ( m.isAdmin ? " user-menu-team-admin" : "")}
                                            onClick={() => this.props.switchTeam(m.team)}
                                        >{m.name}</div>)}
                                    </div>
                                </div>
                            </> : <>
                                <div className="user-menu-team-current">{this.props.team.name}</div>
                                <div
                                    className="user-menu-team-switch"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.setState({ switchTeam: true });
                                    }}
                                >Switch</div>
                            </>}
                            <div style={{ clear: 'both' }} />
                        </div> : ""}

                        {checklist.length > 0 && <>  
                            <h2>My Checklist</h2>

                            {checklist.slice(0,NUM_NOTIFY).map((c,idx) => <div
                                key={idx}
                                className="user-notification"
                                style={{
                                    backgroundImage: "url('https://static.stax.ai/images/notify/tick.png')"
                                }}
                            >
                                <h1>{c.title}</h1>
                                <h2>{c.subtitle}</h2>
                                <p>{c.body && renderHTML(c.body)}</p>
                            </div>)}

                            {checklist.length > NUM_NOTIFY && <div className="user-more">{checklist.length - NUM_NOTIFY} more thing{checklist.length > NUM_NOTIFY+1 ? "s" : ""} to do!</div>}
                        </>}

                        <h2>Notifications</h2>

                        {nNotify > 0 ? <>
                            {user.notifications.slice(0,NUM_NOTIFY).map((n,idx) => <div
                                key={idx}
                                className="user-notification"
                                style={{
                                    backgroundImage: "url('https://static.stax.ai/images/notify/" + this.getNotificationIcon(n) + "')"
                                }}
                            >
                                <img
                                    src="https://static.stax.ai/images/icons/close.png"
                                    alt="x"
                                    title="Clear notification"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.props.clearNotification(idx);
                                    }}
                                />
                                <h1>{n.title}</h1>
                                <h2>{n.timestamp && formatDate(n.timestamp)}</h2>
                                <p>{n.body && renderHTML(n.body)}</p>
                            </div>)}

                            {nNotify > NUM_NOTIFY && <div className="user-more">{nNotify - NUM_NOTIFY} more notification{nNotify > NUM_NOTIFY+1 ? "s" : ""}</div>}

                        </> : <>
                            <div className="user-more">You don't have any notifications.</div>       
                        </>}

                        <h2>Legal</h2>
                        <a href="https://stax.ai/license">Terms of Service</a>
                        <a href="https://stax.ai/privacy">Privacy Policy</a>

                        <h2>Account</h2>
                        <a href="/settings/account">Manage My Account</a>
                        {user.isAdmin && <a href="/settings/team">Manage Team Settings</a>}
                        <a href="https://help.stax.ai" target="_blank" rel="noopener noreferrer">Help Center</a>
                        <a href="/login" style={{ marginBottom: 20 }}>Logout</a>

                    </> : <>
                        {/* This is a marketing opportunity! Get user to sign up for Stax·ai! */}
                        <div className="public-user-menu-cta-header" />
                            
                        <div className="public-user-menu-cta-title">
                            Search through <strong>all</strong> of your documents using <strong>AI</strong>!
                        </div>

                        <div className="public-user-menu-cta-description">
                            <strong>STAX<span className="staxai-logo-dot" />AI</strong> uses <strong>artificial intelligence</strong> to read and index PDFs, scanned documents, handwritten forms, and even pictures from your phone. It provides you a <strong>complete search engine</strong> to find anything within your documents instantly!
                        </div>

                        <a className="public-learn-more" href="https://stax.ai/">Learn more about Stax<span className="staxai-logo-dot" />ai</a>

                        <div className="public-login">
                            Already have an account?<a style={{ display: 'inline' }} href="/login">Login</a>
                        </div>
                    </>}

                </div>
            </div>
        </>);
    }

}